import { type ReactElement } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { FeaturedInfoCard } from "@/components/adg4/featured-info-card/src/featured-info-card";
import {
    FeaturedInfoHeader,
    LAUNCH,
    PLAN,
    REPORT,
    TRACK,
    type FeaturedInfoHeaderProps
} from "@/components/adg4/featured-info-header/src/featured-info-header";
import { TypographyStyles } from "@/libraries/wpl/foundations/src";

const featuresSectionStyles = css({
    background: "#F8F8F8",
    padding: "48px 0"
});

const featuresGridStyles = css({
    display: "grid",
    position: "relative",
    gridTemplateColumns: "1fr",
    gap: "32px",
    margin: "0 32px",

    [media.above.sm]: {
        "maxWidth": "min(1168px, calc(100% - 120px))",
        "margin": "0 auto",
        "gridTemplateColumns": "repeat(2, 1fr)",

        "& > div:first-of-type:has(~ div:last-of-type:nth-of-type(odd))": {
            gridColumn: "span 2"
        }
    }
});

export type FeaturedInfoSectionProps = FeaturedInfoHeaderProps & {
    children:
        | ReactElement<typeof FeaturedInfoCard>
        | ReactElement<typeof FeaturedInfoCard>[];
};

export { PLAN, TRACK, LAUNCH, REPORT };

export const FeaturedInfoSection = ({
    variant,
    eyebrow,
    header,
    description,
    children
}: FeaturedInfoSectionProps) => {
    return (
        <section css={featuresSectionStyles}>
            <TypographyStyles>
                <FeaturedInfoHeader
                    variant={variant}
                    eyebrow={eyebrow}
                    header={header}
                    description={description}
                />
                <div css={featuresGridStyles}>{children}</div>
            </TypographyStyles>
        </section>
    );
};
